import React, { useState } from 'react';
import '../styles/Media.css';
import { useTranslation } from 'react-i18next';
import { AS_SEEN_IN, NEWS_EYEBROW, NEWS_SUBTITLE, NEWS_TITLE } from '../data/navbar/menu';
import NEWS_ARTICLES from '../data/news/news';
import MediaCard from './MediaCard'
import JumboContainer from './common/JumboContainer';

const OUTLETS = NEWS_ARTICLES.reduce((unique, item) => {
  if (!unique.some((outlet) => outlet.medianame === item.medianame)) {
    unique.push({ medianame: item.medianame, medialogo: item.medialogo });
  }
  return unique;
}, []);

const OutletLogo = ({ medianame, medialogo }) => {
  const [broken, setBroken] = useState(false);
  return broken ? (
    <span className="outlet-fallback">{medianame}</span>
  ) : (
    <img
      className="outlet-logo"
      src={medialogo}
      alt={medianame}
      onError={() => setBroken(true)}
    />
  );
}

const Media = (props) => {
  const {t} = useTranslation();
  const marqueeArticles = [...NEWS_ARTICLES, ...NEWS_ARTICLES];

  return(
    <JumboContainer id="news" eyebrow={t(NEWS_EYEBROW)} title={t(NEWS_TITLE)} subtitle={t(NEWS_SUBTITLE)} >
      <div className="news-lines" aria-hidden="true">
        <svg viewBox="0 0 620 640" preserveAspectRatio="xMidYMid slice">
          <g stroke="rgba(15, 120, 100, 0.16)" strokeWidth="1.2" fill="none">
            <path d="M60,420 L260,360 L520,430 L480,560 L180,600 L40,540 Z" />
            <path d="M260,360 L340,240 L560,300 L520,430 Z" />
            <path d="M60,420 L120,300 L260,360 Z" />
            <path d="M340,240 L400,140 L560,180 L560,300 Z" />
          </g>
          <g stroke="rgba(15, 120, 100, 0.13)" strokeDasharray="3,4">
            <line x1="180" y1="80" x2="300" y2="330" />
            <line x1="180" y1="80" x2="470" y2="240" />
            <line x1="180" y1="80" x2="500" y2="470" />
          </g>
          <circle cx="180" cy="80" r="4" fill="#0f9045" />
          <circle cx="180" cy="80" r="9" fill="#0f9045" opacity="0.2" />
        </svg>
      </div>

      <div className="as-seen-in">
        <div className="as-seen-in-label">{t(AS_SEEN_IN)}</div>
        <div className="outlet-row">
          {OUTLETS.map((outlet) => (
            <OutletLogo key={outlet.medianame} medianame={outlet.medianame} medialogo={outlet.medialogo} />
          ))}
        </div>
      </div>

      <div className="marquee-wrap">
        <div className="marquee-track">
          {marqueeArticles.map((item, index) => (
            <MediaCard
              key={`${item.key}-${index}`}
              image={item.image}
              title={item.title}
              link={item.link}
              medianame={item.medianame}
              medialogo={item.medialogo}
            />
          ))}
        </div>
      </div>
    </JumboContainer>
  );
}

export default Media;
